import { useEffect, useRef, useState } from "react";
import { Tooltip } from 'react-tooltip';

export default function LineClamp({ text, ...rest }) {
  const ref = useRef(null);
  const [isClamped, setIsClamped] = useState(false);

  useEffect(() => {
    const el = ref.current;

    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [text]);

  return <>
    <div ref={ref}
      className="line-clamp-2-default"
      data-tooltip-id={isClamped ? `line-clamp-tooltip` : ''}
      data-tooltip-content={isClamped ? text : null} {...rest}>{text}</div>
    <Tooltip id="line-clamp-tooltip" place="bottom" />
  </>;
};